<template lang="pug">
  r-form(
    no-submit
    ref='form'
    reset-text='refrescar'
    v-bind='formProps'
    v-model='slSaleDocument'
    @reset='reset'
    )
</template>

<script>
  //
  import { RForm } from '@/components/reusable_components/next'
  import SlSaleDebitNoteFields from '@/views/Sale/SlSaleDebitNote/SlSaleDebitNoteFields'
  import SlSaleInvoiceFields from '@/views/Sale/SlSaleInvoice/SlSaleInvoiceFields'
  import SlTaxDocumentModel from '@/models/Sale/SlTaxDocument'
  //
  export default {
    name: 'sl-tax-document-detail',
    components: {
      RForm,
    },
    computed: {
      isValid() {
        return this.value.constructor === SlTaxDocumentModel
      },
      formProps() {
        return {
          fields: this.slSaleDocumentFields,
        }
      },
    },
    data() {
      return {
        slSaleDocument: {},
        slSaleDocumentFields: [],
        slSaleDocumentFieldsMap: new Map()
          .set('boleta_electrónica', [])
          .set('factura_electrónica', SlSaleInvoiceFields.readonly())
          .set('nota_de_crédito', [])
          .set('nota_de_débito', SlSaleDebitNoteFields.variant('update').readonly()),
      }
    },
    methods: {

      /**
       * Fetches the object.
       *
       * @return     {<type>}  { description_of_the_return_value }
       */
      fetch() {
        return this
          .wait(true)
          .then(this.getSlSaleDocument)
          .then(this.setSlSaleDocument)
          .then(this.wait)        
      },

      /**
       * Gets the sl sale document.
       *
       * @return     {<type>}  The sl sale document.
       */
      getSlSaleDocument() {
        return this
          .value
          .fetchSaleDocument()
      },

      /**
       * Resets the object.
       */
      reset() {
        if (this.isValid) this.fetch()
      },

      /**
       * Sets the sl sale document.
       *
       * @param      {<type>}  slSaleDocument  The sl sale document
       */
      setSlSaleDocument(slSaleDocument) {
        this.slSaleDocument = slSaleDocument.reset()
        this.slSaleDocumentFields = this.slSaleDocumentFieldsMap.get(this.value.type_code)
      },

      /**
       * { function_description }
       *
       * @param      {boolean}  [val=false]  The value
       * @return     {<type>}   { description_of_the_return_value }
       */
      wait(val = false) {
        return this
          .$refs
          .form
          .setWait(val)
      },
    },
    props: {
      value: {
        type: SlTaxDocumentModel,
        value: null,
      }
    },
    watch: {
      value() {
        this.reset()
      }
    },
    mounted() {
      this.reset()
    }
  }
</script>
